export default __webpack_public_path__ + "static/media/convocatoria2.723d165b.jpeg";